export enum IPageStatus {
    TEASER = 'TEASER',
    SUPER_EARLY = 'SUPER_EARLY', // 超早鸟
    EARLY = 'EARLY', // 早鸟
    REGULAR = 'REGULAR', // 普通
}
